
import { RESET_PASSWORD_REQUESTING, RESET_PASSWORD_REQUEST_ERROR, RESET_PASSWORD_REQUESTED } from 'actions'
import { parse } from 'component-querystring'

const query = window.location.search.slice(1)

const initialState = {
  token: parse(query).token,
  invalidToken: false,
  didError: null,
  loading: false,
  errorStatus: 0
}

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case RESET_PASSWORD_REQUESTING:
      return {
        ...state,
        didError: null,
        isRequesting: true
      }
    case RESET_PASSWORD_REQUEST_ERROR:
      return {
        ...state,
        didError: true,
        errorStatus: payload.error.status,
        isRequesting: false
      }
    case RESET_PASSWORD_REQUESTED:
      return {
        ...state,
        didError: null,
        isRequesting: false
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/application/reset.js